import { useEffect, useState } from 'react';

import { Snackbar } from '@material-ui/core';
import { Alert, AlertTitle } from '@material-ui/lab';

import * as socketEvents from 'constants/socketEvents';
import socket from 'services/socket';

export default function AlertConnectError() {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const handlerConnectError = () => setOpen(true);
    const handlerReconnect = () => setOpen(false);

    socket.on(socketEvents.ON_CONNECT, handlerReconnect);

    socket.on(socketEvents.ON_CONNECT_ERROR, handlerConnectError);
    socket.on(socketEvents.ON_RECONNECT, handlerReconnect);

    return () => {
      socket.off(socketEvents.ON_CONNECT_ERROR, handlerConnectError);
      socket.off(socketEvents.ON_RECONNECT, handlerReconnect);
      socket.off(socketEvents.ON_CONNECT, handlerReconnect);
    };
  }, []);

  return (
    <Snackbar
      key="connect_error"
      autoHideDuration={6000}
      anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      open={open}
    >
      <Alert severity="error" variant="filled">
        <AlertTitle>Você está desconectado!</AlertTitle>
        Estamos tentando estabelecer a conexão com o servidor...
      </Alert>
    </Snackbar>
  );
}
